import { IRootState } from '../../../store'
import { IIntubationState } from '../store/intubation.types'

export const getIntubationSelector = (state: IRootState): IIntubationState => state.intubation
